








































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ConfigUsuarioStore from '@/components/Configuracoes/store/ConfigUsuarioStore'
import { DataTablePagination } from '@/types/interfaces/EmailMensagem'
import { maskCPFCNPJ, getUfs, onlyNumber } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import _ from 'lodash'
import { SuporteFeedbackModalDataProps } from '@/components/modals/SuporteFeedbackModal.vue'

@Component
export default class ViewConfiguracaoPessoa extends Vue {
  $refs!: { formPessoa: any }

  edtPessoa: boolean = false
  showSuporteFeedbackModal: boolean = false
  suporteFeedbackModalData: SuporteFeedbackModalDataProps[] = []

  get editPessoa() { return this.edtPessoa }
  set editPessoa(value: boolean) { this.edtPessoa = value }

  @Watch('editPessoa')
  onChangeEditPessoa(value: boolean) {
    if (!value) {
      this.$refs.formPessoa.resetValidation()
      this.$refs.formPessoa.reset()
    }
  }

  pessoaId: string = ''

  loadPessoas: boolean = true
  get loadingPessoas() { return this.loadPessoas }
  set loadingPessoas(value: boolean) { this.loadPessoas = value }

  get getConfigUsuarioStore() { return getModule(ConfigUsuarioStore, this.$store) }

  get searchPessoa() { return this.getConfigUsuarioStore.searchPessoa }
  set searchPessoa(value: string) { this.getConfigUsuarioStore.setSearchPessoa(value) }

  @Watch('searchPessoa')
  async onChangeSearchPessoa(value: string) {
    this.loadingPessoas = true
    await this.pessoaPagedDebounce(this.pagination)
    this.loadingPessoas = false
  }

  get pessoas() { return this.getConfigUsuarioStore.pessoasAgendamento }
  get getPessoaId() { return this.pessoaId }
  set setPessoaId(value: string) { this.pessoaId = value }

  get pagination() { return this.getConfigUsuarioStore.pagination }

  get configUsuariosTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome', sortable: false },
      { text: 'CPF', class: 'table-headers', align: 'left', value: 'cpf', sortable: false },
      { text: 'Email', class: 'table-headers', align: 'left', value: 'email', sortable: false },
      { text: 'Telefone', class: 'table-headers', align: 'left', value: 'telefone', sortable: false },
      { text: 'Documento', class: 'table-headers', align: 'left', value: 'conselhoTipo', sortable: false },
      { text: 'Tem Login', class: 'table-headers', align: 'left', value: 'temLogin', sortable: false },
      { text: 'Ações', class: 'table-headers', align: 'center', value: '', sortable: false },
    ]
  }

  get ufs() { return [...getUfs()] }

  maskCPFCNPJUtil(value: string) { return maskCPFCNPJ(value) }

  onlyNumberUtil(value: any) { return onlyNumber(value) }

  pessoaPagedDebounce = _.debounce(param => this.getConfigUsuarioStore.getAllPessoaAgendamento(param), 700)

  async updatePagination(pagination: DataTablePagination) {
    this.loadingPessoas = true
    await this.pessoaPagedDebounce(pagination)
    this.loadingPessoas = false
  }

  async resetSearch() {
    this.getConfigUsuarioStore.clearPagination()
    this.loadingPessoas = true
    await this.pessoaPagedDebounce(this.pagination)
    this.loadingPessoas = false
  }

  async abrirModalEditarPessoa(id: string) {
    this.pessoaId = id
    const response = await this.getConfigUsuarioStore.getPessoaAgendamentoById(id)
    if (response.success) {
      this.editPessoa = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Ocorreu erro ao buscar a pessoa.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.pessoaId = ''
  }

  closeSuporteFeedbackModal() {
    this.pessoaPagedDebounce(this.pagination)
    this.$refs.formPessoa.resetValidation()
    this.$refs.formPessoa.reset()
    this.editPessoa = false
    this.showSuporteFeedbackModal = false
    this.suporteFeedbackModalData = []
  }

  async editarPessoa() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    const response = await this.getConfigUsuarioStore.atualizaPessoaAgendamento()
    if (response.success) {
      EventBus.$emit('clearLoadingRequest')
      this.suporteFeedbackModalData = response.data
      this.showSuporteFeedbackModal = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Ocorreu erro ao enviar os dados.',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    await this.getConfigUsuarioStore.getAllPessoaAgendamento(this.pagination)
    EventBus.$emit('clearLoadingRequest')
  }

  beforeDestroy() {
    this.getConfigUsuarioStore.clearPessoasAgendamento()
    this.getConfigUsuarioStore.clearPessoaAgendamento()
  }
}
